<template>
  <div>
    <SubTitle text="Datos generales"/>
    <div class="card-section">
      <el-row :gutter="18">
        <el-form>
          <el-col>
            <el-form-item label="Modo de planificación" class="mode-item">
              <el-radio-group v-model="alg_settings.simpli_mode" size="mini">
                <el-radio-button :label="true">SimpliRoute</el-radio-button>
              </el-radio-group>
              <el-checkbox v-model="sendVLs" class="send-vls">
                Enviar Cargas
              </el-checkbox>
            </el-form-item>
          </el-col>
          <el-col v-show="sendVLs">
            <el-form-item label="Cargas a informar a SimpliRoute (opcional)"
                          class="load-attributes-item">
              <div class="load-attribute-groups">
                <div class="load-attribute-group">
                  <span class="load-attribute-label">CARGA1</span>
                  <el-select v-model="loadAttributes.load"
                             size="mini"
                             class="load-attribute-select"
                             placeholder="Automático">
                    <el-option v-for="option in loadAttributeOptions"
                               :key="`load-${option.value}`"
                               :label="option.label"
                               :value="option.value"
                               :disabled="isOptionUsedElsewhere('load', option.value)"/>
                  </el-select>
                </div>
                <div class="load-attribute-group">
                  <span class="load-attribute-label">CARGA2</span>
                  <el-select v-model="loadAttributes.load2"
                             size="mini"
                             class="load-attribute-select"
                             placeholder="Automático">
                    <el-option v-for="option in loadAttributeOptions"
                               :key="`load2-${option.value}`"
                               :label="option.label"
                               :value="option.value"
                               :disabled="isOptionUsedElsewhere('load2', option.value)"/>
                  </el-select>
                </div>
                <div class="load-attribute-group">
                  <span class="load-attribute-label">CARGA3</span>
                  <el-select v-model="loadAttributes.load3"
                             size="mini"
                             class="load-attribute-select"
                             placeholder="Automático">
                    <el-option v-for="option in loadAttributeOptions"
                               :key="`load3-${option.value}`"
                               :label="option.label"
                               :value="option.value"
                               :disabled="isOptionUsedElsewhere('load3', option.value)"/>
                  </el-select>
                </div>
              </div>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item label="CT / CTT">
              <el-select  v-model="ct"
                          value-key="select_key"
                          size="mini"
                          filterable
                          placeholder="Ej: Local Internet">
                          <el-option
                        v-for="ct in ctsAndCtts"
                          :key="ct.select_key"
                          :label="ct.name"
                          :value="ct"
                        >
                  <img :src="require(`@/assets/img/bus/${getBuImageName(ct.bu)}.svg`)"
                       class="label-img-ct">
                  {{ct.name}}
                  <span class="label-id-ct"> · {{ct.id}}</span>
                  <span class="label-facility-ct">{{ct.facility}}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="12">

          </el-col>
          <el-col :md="12">
            <el-form-item label="Fecha">
              <div class="datePicker">
                <el-date-picker v-model="date"
                                size="mini"
                                :clearable="false"
                                format="dd-MM-yyyy"
                                value-format="yyyy-MM-dd"
                                placeholder="Fecha"
                                :picker-options="pickerOptions">
                </el-date-picker>
              </div>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item label="Inicio">
              <el-time-picker format="HH:mm"
                              size="mini"
                              :clearable="false"
                              value-format="HH:mm"
                              v-model="timeInit"
                              placeholder="09:00">
              </el-time-picker>
            </el-form-item>
          </el-col>
          <el-col :md="12">
            <el-form-item label="Término">
              <el-time-picker format="HH:mm"
                              size="mini"
                              :clearable="false"
                              value-format="HH:mm"
                              v-model="timeFinish"
                              placeholder="12:00">
              </el-time-picker>
            </el-form-item>
          </el-col>
          <el-col v-show="alg_settings.simpli_mode">
            <el-divider/>

          </el-col>
        </el-form>
      </el-row>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import SubTitle from '../../base/SubTitle.vue';
import { cachedAPIRequest } from '../../../../mixins/cacheDim';

export default {
  props: {
    value: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  name: 'ExtraData',
  components: {
    SubTitle,
  },
  data() {
    return {
      ct: {},
      cts: [],
      ctts: [],
      sendVLs: false,
      loadAttributes: {
        load: '',
        load2: '',
        load3: '',
      },
      loadAttributeOptions: [
        { value: '', label: 'Automático (valor por defecto)' },
        { value: 'volume', label: 'Volumen' },
        { value: 'weight', label: 'Peso' },
        { value: 'monetary', label: 'Monto asegurado' },
      ],
      trafficFactors: [1.0, 1.5, 2.0, 3.0],
      alg_settings: {
        simpli_mode: true,
        balance: true,
        all_vehicles: true,
        back_to_cd: false,
        multi_trip: false,
        euclidian_distance: true,
        traffic_factor: 1.5,
        simplify: false,
        fmb: 1,
        enable_soft_window: false,
      },
      travelType: {},
      travelTypes: [],
      timeInit: '09:00',
      timeFinish: '21:00',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < new Date(Date.now() - 86400000);
        },
      },
      date: moment(new Date(Date.now())).format('YYYY-MM-DD'),
    };
  },
  mounted() {
    this.getCts();
    this.getCtts();
    this.sendData();
    this.getTravelTypes();
  },
  watch: {
    value: {
      handler() {
        this.syncCt(this.value.ct);
        if (this.value.alg_settings) this.alg_settings = this.value.alg_settings;
        this.travelType = this.value.travel_type;
        this.timeInit = moment(this.value.time_init).format('HH:mm');
        // this.date = moment(this.value.time_init).format('YYYY-MM-DD');
        this.timeFinish = moment(this.value.time_finish).format('HH:mm');
      },
      deep: true,
    },
    ct() {
      this.sendData();
    },
    alg_settings: {
      handler() {
        this.sendData();
      },
      deep: true,
    },
    travelType() {
      this.sendData();
    },
    sendVLs() {
      this.sendData();
    },
    loadAttributes: {
      handler() {
        this.sendData();
      },
      deep: true,
    },
    timeInit() {
      if (this.timeInit === null) this.timeInit = '09:00';
      this.sendData();
    },
    timeFinish() {
      if (this.timeFinish === null) this.timeInit = '09:00';
      this.sendData();
    },
    date() {
      if (this.date === null) this.date = moment(new Date(Date.now())).format('YYYY-MM-DD');
      this.sendData();
    },
  },
  methods: {
    sendData() {
      this.$emit('input', this.getData());
      this.$emit('errors', this.getErrors());
    },
    getCtSelectKey(ct) {
      const facility = ct && ct.is_ctt ? 'ctt' : 'ct';
      const id = ct && ct.id ? ct.id : '';
      const name = ct && ct.name ? ct.name : '';
      return `${facility}-${id}-${name}`;
    },
    normalizeCt(ct) {
      if (!ct || !ct.id) return {};
      return {
        ...ct,
        select_key: ct.select_key || this.getCtSelectKey(ct),
      };
    },
    resolveCt(ct) {
      if (!ct || !ct.id) return {};
      const normalizedCt = this.normalizeCt(ct);
      const match = this.ctsAndCtts.find(option => option.select_key === normalizedCt.select_key);
      return match || normalizedCt;
    },
    syncCt(ct) {
      const nextCt = this.resolveCt(ct);
      const currentKey = this.ct && this.ct.select_key ? this.ct.select_key : '';
      const nextKey = nextCt && nextCt.select_key ? nextCt.select_key : '';

      if (currentKey !== nextKey) {
        this.ct = nextCt;
      }
    },
    getData() {
      return {
        ct: this.normalizeCt(this.ct),
        alg_settings: this.alg_settings,
        time_init: this.getTimeInit,
        travel_type: this.travelType,
        time_finish: this.getTimeFinish,
        send_vls: this.sendVLs,
        load_attributes: this.loadAttributes,
      };
    },
    isOptionUsedElsewhere(field, value) {
      if (value === '') return false;
      return ['load', 'load2', 'load3']
        .filter(key => key !== field)
        .some(key => this.loadAttributes[key] === value);
    },
    getErrors() {
      const err = [];
      if (this.date === null) err.push('Fecha incorrecta');
      if (this.timeInit === null) err.push('Hora de inicio incorrecta');
      if (this.timeFinish === null) err.push('Hora de termino incorrecta');
      if (!this.ct.id) err.push('Seleccione un centro de distribución');
      const selectedLoadAttributes = [
        this.loadAttributes.load,
        this.loadAttributes.load2,
        this.loadAttributes.load3,
      ].filter(value => value !== '');
      const uniqueCount = new Set(selectedLoadAttributes).size;
      const hasDuplicateLoadAttributes = uniqueCount !== selectedLoadAttributes.length;
      if (hasDuplicateLoadAttributes) {
        err.push('No se puede informar el mismo atributo de carga (volumen/peso/monto) en más de un campo');
      }
      return err;
    },
    getCts() {
      cachedAPIRequest({
        module: 'planning',
        service: 'distribution_centers',
        params: { limit: 1000 },
      }).then((response) => {
        this.cts = response.data.map(ct => ({
          id: ct.id,
          name: ct.name,
          is_ctt: false,
          select_key: this.getCtSelectKey(ct),
          facility: ct.facility,
          bu: ct.business_unit ? ct.business_unit.name : '',
        }));
        this.syncCt(this.ct);
      }).catch(() => {
        this.$notify.error({
          title: 'Error',
          message: 'Error al cargar los ct',
        });
      });
    },
    getCtts() {
      cachedAPIRequest({
        module: 'planning',
        service: 'transfer_center',
        params: { limit: 1000 },
      }).then((response) => {
        this.ctts = response.data.map(ct => ({
          id: ct.id,
          name: ct.name,
          is_ctt: true,
          select_key: this.getCtSelectKey({ ...ct, is_ctt: true }),
          facility: 'ctt',
          bu: ct.business_unit ? ct.business_unit.name : '',
        }));
        this.syncCt(this.ct);
      }).catch(() => {
        this.$notify.error({
          title: 'Error',
          message: 'Error al cargar los ct',
        });
      });
    },
    getTravelTypes() {
      cachedAPIRequest({
        module: 'planning',
        service: 'travel_types',
        params: { limit: 1000 },
      }).then((response) => {
        this.travelTypes = response.data
          .map(travelType => ({ id: travelType.id, name: travelType.type }))
          .sort((a, b) => (b.name > a.name ? -1 : 1));
      }).catch(() => {
        this.$notify.error({
          title: 'Error',
          message: 'Error al cargar los tipos de viaje',
        });
      });
    },
    getBuImageName(bu) {
      let buName = 'generic';
      if (bu === 'FCOM') {
        buName = 'fcom';
      } else if (bu === 'Sodimac') {
        buName = 'sodimac';
      } else if (bu === 'Falabella') {
        buName = 'falabella';
      }
      return buName;
    },
  },
  computed: {
    getTimeInit() {
      return this.date && this.timeInit
        ? moment(`${this.date}T${this.timeInit}`).toISOString() : null;
    },
    getTimeFinish() {
      return this.date && this.timeFinish
        ? moment(`${this.date}T${this.timeFinish}`).toISOString() : null;
    },
    ctsAndCtts() {
      return this.cts.concat(this.ctts).sort((a, b) => (b.name > a.name ? -1 : 1));
    },
  },
};
</script>

<style lang="scss" scoped>
  .card-section {
    border-radius: 3px;
    border: 1px solid #E0E0E0;
    padding: 20px 16px 0;
    .el-form-item { margin-bottom: 12px; }
    .mode-item {
      .el-radio-group {
        width: auto;
        vertical-align: middle;
      }
      .send-vls {
        margin-left: 20px;
        vertical-align: middle;
      }
    }
    .load-attributes-item {
      .el-form-item__label {
        display: block;
        float: none;
        width: auto;
        text-align: left;
      }
      .el-form-item__content {
        margin-left: 0 !important;
      }
      .load-attribute-groups {
        display: flex;
        flex-wrap: nowrap;
        gap: 8px;
      }
      .load-attribute-group {
        display: flex;
        flex-direction: column;
        flex: 1 1 0;
        min-width: 0;
        max-width: 110px;
      }
      .load-attribute-label {
        font-size: 10px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.4px;
        color: $fb-grey-light-50;
        margin-bottom: 2px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .load-attribute-select {
        width: 100%;
        .el-input__inner { width: 100%; }
      }
    }
    .el-divider { margin: 0 0 15px 0; }
    .el-form-item__content > .el-slider { padding-top: 10px; }
    .simpli-alg {
      width: 100%;
      padding-top: 8px;
      display: inline-block;
      .el-radio-group {
        width: 105px;
        float: left;
      }
      .el-slider {
        float: right;
        margin-top: -4px;
        width: calc(100% - 105px);
      }
    }
  }
  .label-id-ct { color: $fb-grey-light-70; }
  .label-facility-ct {
    height: 18px;
    padding: 0 8px;
    margin: 8px 0;
    line-height: 1.3;
    float: right;
    color: $fb-grey-light-50;
    background-color: $fb-grey-light-94;
    border-radius: 2px;
    font-size: 12px;
    letter-spacing: 0.4px;
  }
  .label-img-ct {
    height: 20px;
    display: block;
    float: left;
    margin: 7px 7px 0 0;
  }
  .info-simpli {
    .el-collapse-item__content {
      padding-bottom: 8px !important;
    }
    .info-simpli-title {
      color: #666;
      i {
        font-size: 20px;
        color: $fb-amber;
        margin-right: 4px;
        vertical-align: middle;
      }
    }
    .info-simpli-content {
      text-align: justify;
      line-height: 1.1;
      color: $fb-grey-light-50;
      .info-simpli-description {
        display: block;
        margin-bottom: 8px;
        span { font-weight: 800; }
      }
    }
  }
</style>
